<template>
  <div>

    
    <!-- Footer -->
    <footer>
      <div class="container-fluid">
        <div class="footer-content mb-2">
          <div class="row">
            <div class="col-lg-2">
              <div class="footer-logo">
                <div class="bg-title mb-2">AISN</div>
                <div class="text text-uppercase">Academic Institute for Special Needs (AISN) </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="footer-links">
                <router-link class="footer-link"
              v-if="(header[0]) ? header[0].status : false"
              to="/accreditations">Accreditation</router-link>

            <router-link class="footer-link"
              v-if="(header[8]) ? header[8].status : false"
              to="/our-certificates">Certification</router-link>

            <router-link class="footer-link"
              v-if="(header[3]) ? header[3].status : false"
              to="/about">About</router-link>

            <router-link class="footer-link"
              v-if="(header[1]) ? header[1].status : false"
              to="/programs">Programs</router-link>

            <router-link class="footer-link"
              v-if="(header[2]) ? header[2].status : false"
              to="/memberships">Membership</router-link>

            <router-link class="footer-link"
              v-if="(header[4]) ? header[4].status : false"
              to="/contact">Contact us</router-link>

            <router-link class="footer-link"
              v-if="(header[7]) ? header[7].status : false"
              to="/online-trainings">Online Training</router-link>

            <router-link class="footer-link"
              v-if="(header[6]) ? header[6].status : false"
              to="/events">Events & Conferences</router-link>

            <router-link v-for="(pg, idx) in pages" :key="idx"
                :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}</router-link>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="newsletter">
                <div class="title white-color mb-2">News</div>
                <div class="form-group d-flex justify-content-between">
                  <input v-model="email" type="text" class="form-control" placeholder="Your mail here..." />
                  <button @click="newsletter" class="subscribe-btn">Subscribe 
                      <span class="icon-arrow-right ml-2 icon"></span>
                  </button>
                </div>
                <div v-if="success" style="color: #080" class="alert-msg">email sent successfully.</div>
              <div v-if="error" style="color: #f00" class="alert-msg">this email not valid.</div>
              </div>
            </div>
          </div>
          
        </div>
        <div class="footer-bottom d-flex justify-content-between">
          <div class="fb-text">2021 All Rights Reserved © AISN Academic Institute for Special Needs  
            <router-link class="ml-2"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link>
          </div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">
              
              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>

            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer -->


  </div>
</template>

<style scoped>
.alert-msg {
  padding: 10px 0;
  font-size: 17px;
}
</style>


<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      pages: [],
      success: false,
      error: false,
    };
  },
  created() {

      axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
      
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + '/newsletters',
        method: "POST",
        data: {
          email: this.email
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
          // alert(res.data.message);
        })
        .catch((err) => {
          console.log(err);
          this.success = false;
          this.error = true;
          // alert(err.message);
        });
    }
  }
};
</script>
